import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import { EpisodeModel } from '../../../network/rest';
import './style.scss';
import { links } from '../../../utils/staticContent';

interface Props {
    data: EpisodeModel;
}

function ListItemWithDescription({ data }: Props) {
    return (
        <Link
            to={`${'showId' in data ? links.shows + `/${data.showId}` : links.articles}/${data.id}`}
            className="ListItemWithDescription"
        >
            <h2 className="title">
                {'episodeNumber' in data ? `EP ${data.episodeNumber} - ` : ''}
                {data.title}
            </h2>
            <div className="content">
                <div className="left-content">
                    {data.fileUrl && (
                        <img src={data.fileUrl as unknown as string} alt={data.title} />
                    )}
                </div>
                <div className="right-content">
                    {data.shortContent ? parse(data.shortContent) : ' '}
                </div>
            </div>
        </Link>
    );
}

export default ListItemWithDescription;
